// MapMarkerIcon.jsx
// Generates custom Leaflet DivIcon markers using the same module SVG assets
// (assest/svg) used elsewhere in the app (sidebar, Executive RegionalMap),
// coloured per facility/market type.

import L from 'leaflet';
import { FACILITY_TYPES, TYPE_COLORS } from './mockData/GeospatialData';
import IconInfrastructure from '../../assest/svg/Infrastructure.svg';
import IconMarkets from '../../assest/svg/Market.svg';
import IconAnimalHealth from '../../assest/svg/AnimalHealth.svg';
import IconAnimalIdentity from '../../assest/svg/AnimalIdentity.svg';
import IconPlanning from '../../assest/svg/Planning.svg';
import IconLivestock from '../../assest/svg/Livestock.svg';

// Every facility/market type maps to the closest matching module icon —
// there's no per-facility-type icon set, so several types share one glyph
// and are told apart by their marker colour (TYPE_COLORS) instead.
const TYPE_ICONS = {
  [FACILITY_TYPES.ABATTOIR]: IconInfrastructure,
  [FACILITY_TYPES.SLAUGHTER_SLAB]: IconInfrastructure,
  [FACILITY_TYPES.COLD_STORAGE_COMMERCIAL]: IconInfrastructure,
  [FACILITY_TYPES.COLD_STORAGE_BIOLOGICAL]: IconInfrastructure,
  [FACILITY_TYPES.OTHER]: IconInfrastructure,

  [FACILITY_TYPES.MARKET]: IconMarkets,
  [FACILITY_TYPES.LIVE_ANIMAL_MARKET]: IconMarkets,

  [FACILITY_TYPES.VETERINARY_CLINIC]: IconAnimalHealth,
  [FACILITY_TYPES.VETERINARY_HOSPITAL]: IconAnimalHealth,
  [FACILITY_TYPES.LABORATORY]: IconAnimalHealth,
  [FACILITY_TYPES.DIAGNOSTIC_CENTRE]: IconAnimalHealth,
  [FACILITY_TYPES.QUARANTINE_STATION]: IconAnimalHealth,

  [FACILITY_TYPES.AI_CENTRE]: IconAnimalIdentity,

  [FACILITY_TYPES.PROCESSING]: IconPlanning,

  [FACILITY_TYPES.RANCH]: IconLivestock,
  [FACILITY_TYPES.GRAZING_RESERVE]: IconLivestock,
  [FACILITY_TYPES.BREEDING_FARM]: IconLivestock,
  [FACILITY_TYPES.WATERING_POINT]: IconLivestock,
  [FACILITY_TYPES.MILK_COLLECTION_CENTRE]: IconLivestock,
  [FACILITY_TYPES.FEED_MILL]: IconLivestock,
};

// Round badge-on-a-stick pin — matches the marker style used across the app
// (Executive RegionalMap, Infrastructure map).
export const createMarkerIcon = (type, isSelected = false) => {
  const color = TYPE_COLORS[type] || TYPE_COLORS[FACILITY_TYPES.OTHER];
  const src = TYPE_ICONS[type] || IconInfrastructure;

  const circle = isSelected ? 42 : 36;
  const img = Math.round(circle * 0.5);
  const total = circle + 16;
  const bg = isSelected ? '#f0fdf4' : '#ffffff';
  const shadow = isSelected
    ? `0 0 0 3px ${color}40, 0 4px 14px ${color}66`
    : '0 2px 8px rgba(0,0,0,0.25)';

  const html = `
    <div style="width:${circle + 4}px;height:${total}px;display:flex;flex-direction:column;align-items:center;transition:all .15s ease;">
      <div style="width:${circle}px;height:${circle}px;border-radius:50%;background:${bg};border:2.5px solid ${color};
        box-shadow:${shadow};display:flex;align-items:center;justify-content:center;">
        <img src="${src}" style="width:${img}px;height:${img}px;object-fit:contain;opacity:.85;" alt="" />
      </div>
      <div style="width:2px;height:12px;background:${color};border-radius:0 0 2px 2px;"></div>
      <div style="width:5px;height:3px;border-radius:50%;background:rgba(0,0,0,0.2);margin-top:-1px;"></div>
    </div>`;

  return L.divIcon({
    html,
    className: '',
    iconSize: [circle + 4, total],
    iconAnchor: [(circle + 4) / 2, total],
    popupAnchor: [0, -total],
  });
};
